import { useState } from "react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { Panel } from "@/components/AppShell";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed");
      setCurrent(""); setNext("");
    } catch (err) { toast.error(errorText(err)); }
  };
  return (
    <Panel className="p-5">
      <h2 className="font-display text-2xl font-bold uppercase mb-3">Change password</h2>
      <form onSubmit={submit} className="flex flex-wrap gap-2" data-testid="change-password-form">
        <Input data-testid="current-password-input" type="password" placeholder="Current password" value={current} onChange={(e) => setCurrent(e.target.value)} required className="w-56 bg-slate-900/70" />
        <Input data-testid="new-password-input" type="password" placeholder="New password (8+)" value={next} onChange={(e) => setNext(e.target.value)} required className="w-56 bg-slate-900/70" />
        <Button data-testid="change-password-btn" type="submit" variant="secondary">Save</Button>
      </form>
    </Panel>
  );
}
